// extracted by mini-css-extract-plugin
export default {"buttonContent":"refreshActiveResearchesButton_buttonContent__heCE+"};